var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-button',{class:['trawl-radio-button', _vm.alignClass],attrs:{"value":_vm.radioValue}},[(_vm.hasIconSlot)?_c('div',{staticClass:"trawl-radio-button--icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }